export const createParquetWorker = (): Worker =>
  new Worker(new URL('./parquet.worker.ts', import.meta.url), { type: 'module', name: 'parquet-worker' });
